import { useRef } from 'react';
import { useSelector as useReduxSelector, EqualityFn } from 'react-redux';

import { useStateUpdateEnabled } from './StateUpdateEnabledContext';

export function useSelector<S = unknown, T = unknown>(
  selector: (state: S) => T,
  equalityFn?: EqualityFn<T> | { equalityFn?: EqualityFn<T> }
): T {
  const stateUpdateEnabled = useStateUpdateEnabled();

  const selectedRef = useRef<T>();

  return useReduxSelector((state: S) => {
    if (stateUpdateEnabled || selectedRef.current === undefined) {
      const selected = selector(state);
      // Code to debug what's changing
      // const _equalityFn = typeof equalityFn === 'function' ? equalityFn : equalityFn?.equalityFn;
      // if (
      //   selectedRef.current !== selected &&
      //   (!_equalityFn || (_equalityFn && !_equalityFn(selectedRef.current, selected)))
      // ) {
      //   console.log('selected', selectedRef.current, selected);
      // }
      selectedRef.current = selected;
    }
    return selectedRef.current;
    // react-redux has two overloads (EqualityFn | UseSelectorOptions); our union doesn't match either
  }, equalityFn as EqualityFn<T>);
}
